import { render, staticRenderFns } from "./MilkVatCorrectionsHistory.vue?vue&type=template&id=4db03ff5&"
import script from "./MilkVatCorrectionsHistory.vue?vue&type=script&lang=ts&"
export * from "./MilkVatCorrectionsHistory.vue?vue&type=script&lang=ts&"
import style0 from "./MilkVatCorrectionsHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports